import { brandedUuid } from '../FlavorSchema.js';
export const OrganizationIdSchema = brandedUuid('Invalid organization ID format');
//# sourceMappingURL=OrganizationSchemas.js.map